import { withChartLayout } from 'components/common';
import ReviewOfSystems from 'components/features/chart/provider-chart/history-physical/review-of-systems/ReviewOfSystems';

const ReviewOfSystemsPage = withChartLayout('Review of Systems')(ReviewOfSystems);
export default ReviewOfSystemsPage;
